import { render, staticRenderFns } from "./aviso-servicios-marcados.vue?vue&type=template&id=75ddc21c&scoped=true"
import script from "./aviso-servicios-marcados.vue?vue&type=script&lang=js"
export * from "./aviso-servicios-marcados.vue?vue&type=script&lang=js"
import style0 from "./aviso-servicios-marcados.vue?vue&type=style&index=0&id=75ddc21c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ddc21c",
  null
  
)

export default component.exports